

import React, { useState, useEffect } from 'react';
import 'jodit/build/jodit.min.css';
import JoditEditor from 'jodit-react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalHeader, Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar';
import { API_URL } from '../../../config';
import right from '../../images/right.png';


const NewSoftwareAnnouncement = () => {


  const [uploadingHeadline, setUploadingHeadline] = useState('')

  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const { id } = useParams();
  const [uploadingHeadlineErr, setUploadingHeadlineErr] = useState(false)
  const [uploadContentErr, setUploadContentErr] = useState(false);
  const [errMessage, setErrMessage] = useState('')
  const navigate = useNavigate()
  const [statusFieldErr, setStatusFieldErr] = useState(false);
  const [statusField, setStatusField] = useState('')





  const [uploadContent, setUploadContent] = useState('');

  const handleContentChange = (newContent) => {
    setUploadContent(newContent);
  };

  useEffect(() => {
    if (id) {
      getEditData();
    }

  }, [])

  const getEditData = () => {
    fetch(API_URL + "/get/announcement/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          if (id) {
            setUploadingHeadline(resp.data[0].headline);
            setUploadContent(resp.data[0].content)
            setStatusField(resp.data[0].status)
          }

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const createProfile = () => {
    if (isValidCreate()) {
      let data = {};
      data['headline'] = uploadingHeadline;
      data['content'] = uploadContent;

      fetch(API_URL + "/create/announcement", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',

        },

        body: JSON.stringify(data)

      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            successToggleModal();
            setTimeout(function () { navigate('/edit-software-announcement') }, 5000);
          });

        }
        else if (response.status == 400) {
        }
        else if (response.status == 401) {
          logout()
        }
        else {
          console.log("network error")
        }


      })
    }
    else {

    }

  }
  const handleGoBack = () => {
    if (id) {
      navigate('/edit-software-announcement');
    } else {
      navigate('/software-update');

    }
  }

  const isValidUpdate = () => {
    if (uploadingHeadline == '' && uploadContent == '') {
      setErrMessage("All field required")
    } else if (uploadingHeadline == '') {
      setUploadingHeadlineErr(true);
      setUploadContentErr(false);
      setErrMessage("Field required")
    } else if (uploadContent == '') {
      setUploadContentErr(true);

      setUploadingHeadlineErr(false);
      setErrMessage("Field required")
    } else {
      return true
    }
  }
  const isValidCreate = () => {
    if (uploadingHeadline == '' && uploadContent == '') {
      setErrMessage("Field required")
      setUploadingHeadlineErr(true);
      setUploadContentErr(true);
    } else if (uploadingHeadline.trim() == '') {
      setUploadingHeadlineErr(true);
      setUploadContentErr(false);
      setErrMessage("Field required")
    } else if (uploadContent.trim() == '') {
      setUploadContentErr(true);
      setUploadingHeadlineErr(false);
      setErrMessage("Field required")
    } else if (id && statusField == '') {
      setUploadContentErr(false);
      setStatusFieldErr(true);
      setUploadingHeadlineErr(false);
      setErrMessage("Field required")
    }
    else {
      return true
    }
  }
  const handleUpdate = () => {
    if (isValidCreate()) {
      let data = {}

      data['headline'] = uploadingHeadline
      data['content'] = uploadContent
      data['status'] = statusField;

      fetch(API_URL + "/update/announcement/by/" + id, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',

        },
        body: JSON.stringify(data)
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            successToggleModal();
            setTimeout(function () { navigate('/edit-software-announcement') }, 5000);

          });
        }
        else if (response.status == 400) {
        }
        else if (response.status == 401) {
          logout()
        }
        else {
          console.log("network error")
        }


      })

    }
  }

  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>


        <div className="right-section ">
          <div className="head-listing head-listingb">
            <h3>{id ? "Edit Software Announcement" : "Upload Software Announcement"}</h3>
          </div>

          <div className='right-section-box'>

            {/* =============1==== */}
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Update Headline* </label>
                  <input type="text" value={uploadingHeadline} onChange={(e) => setUploadingHeadline(e.target.value)} className='client-input' placeholder='Enter headline' />
                  {uploadingHeadlineErr ? <div className='linkError'>{errMessage}</div> : ""}

                </div>
              </div>

            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                    Update Content*</label>
                  <JoditEditor
                    value={uploadContent}
                    onChange={handleContentChange}
                  />
                  {uploadContentErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div>
                {id ? <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                    Status*</label>
                  <select value={statusField} onChange={(e) => setStatusField(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Status</option>
                    <option value="1" selected={statusField == 1 ? "Selected" : ''}>Active</option>
                    <option value="0" selected={statusField == 0 ? "Selected" : ''}>Inactive</option>
                  </select>
                  {statusFieldErr ? <div className='linkError'>{errMessage}</div> : ""}
                </div> : ''}
              </div>
            </div>

            {/* ======5====== */}
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                  {id ?
                    <button type="submit" className='btn btn-primary_d' onClick={handleUpdate}>Update
                    </button>
                    : <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Create
                    </button>}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>{id ? "Updated" : "Created"}</h4>
            <p>Software announcement has been {id ? "Updated" : "Created"} successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default NewSoftwareAnnouncement;